export const LOADER_NINE_BOXES         =       'LOADER_NINE_BOXES';
export const GET_NINE_BOXES            =       'GET_NINE_BOXES';
export const NINE_BOXES_FALLA          =       'NINE_BOXES_FALLA';
export const FORM_NINE_BOXES_FAIL      =       'FORM_NINE_BOXES_FAIL';

